module.exports = __webpack_public_path__ + "static/dmon-008-3d49439ff4457d0939227055b282bd04.jpg";